import fetch from '@/utils/fetch';

export function login(param) {
    return fetch({
        url: '/Service/Api/jd?service=ManageUserService&method=login&param=LoginParam',
        method: 'post',
        data: param
    });
}

export function getUserRuleList(param) {
    return fetch({
        url: '/ManageRule/ManageRule/getUserRuleList',
        method: 'post',
        params: param
    });
}

export function logout() {
    return fetch({
        url: '/ManageUser/ManageUser/logout',
        method: 'post'
    });
}

export function passCodeSet(param) {
    return fetch({
        url: '/ManageUser/ManageUser/modifyPassword',
        method: 'post',
        data: param
    });
}

export function userSSet(param) {
    return fetch({
        url: '/ManageUser/ManageUser/updateUserChangePasswordStatus',
        method: 'post',
        data: param
    });
}

export function indexTitle(param) {
    return fetch({
        url: '/Home/Index/title',
        method: 'post',
        data: param
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js